@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

@if (awaitingPackageCreation) {
    <p class="lead">Awaiting Package Creation <span>...</span></p>
}
@if (!awaitingPackageCreation) {
    <table class="table table-striped packages-table">
        <thead>
            <tr>
                <th>Package #</th>
                <th>Created</th>
                <th>Responsible Party</th>
                <th>Cc/Bcc</th>
                @if (isTransmittal) {
                    <th>Transmittals</th>
                }
                @if (!isTransmittal) {
                    <th>Feed</th>
                }
                <th>Payment Count</th>
                <th>Data Hub Status</th>
                <th>Special Instructions</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            @for (package of paymentPackages; track package) {
                <tr
                    [style.font-style]="package.completedDateTime ? 'italic' : 'normal'"
                    [style.color]="package.isRecalled ? '#a3a4b2' : 'var(--ace-neutral-800)'"
                >
                    <td>{{ getPackageNum(package) }}</td>
                    <td>{{ package.completedDateTime ? (package.completedDateTime | weissmanDateFormat) : '' }}</td>
                    <td>
                        @for (recipient of package.paymentPackageRecipients; track recipient) {
                            <div>
                                @if (
                                    recipient.recipientType === recipientTypeMap['responsible'] &&
                                    package.feedType !== checkFeed
                                ) {
                                    <span [tooltip]="recipientAddress" (mouseenter)="setHoveredRecipient(recipient)">
                                        {{ recipient.fullName }}
                                    </span>
                                }
                            </div>
                        }
                        @if (package.feedType === checkFeed) {
                            <div class="text-muted"> Not Applicable </div>
                        }
                    </td>
                    <td>
                        <table>
                            <tr>
                                <td>
                                    @for (recipient of package.paymentPackageRecipients; track recipient) {
                                        <div>
                                            @if (
                                                recipient.recipientType === recipientTypeMap['cc'] &&
                                                package.feedType !== checkFeed
                                            ) {
                                                <div
                                                    class="float-start"
                                                    [tooltip]="recipientAddress"
                                                    (mouseenter)="setHoveredRecipient(recipient)"
                                                >
                                                    <span>CC: </span>
                                                    {{ recipient.fullName }}
                                                </div>
                                            }
                                        </div>
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    @for (recipient of package.paymentPackageRecipients; track recipient) {
                                        <div>
                                            @if (
                                                recipient.recipientType === recipientTypeMap['bcc'] &&
                                                package.feedType !== checkFeed
                                            ) {
                                                <div
                                                    class="float-start"
                                                    [tooltip]="recipientAddress"
                                                    (mouseenter)="setHoveredRecipient(recipient)"
                                                >
                                                    <span>BCC: </span>
                                                    {{ recipient.fullName }}
                                                </div>
                                            }
                                        </div>
                                    }
                                </td>
                            </tr>
                        </table>
                        @if (package.feedType === checkFeed) {
                            <div class="text-muted"> Not Applicable </div>
                        }
                    </td>
                    <td>
                        @if (package.feedType !== checkFeed) {
                            <a style="cursor: pointer" (click)="navigateToBillPaymentPackages(package)">
                                {{ isTransmittal ? 'Transmittal Link' : feedTextMap[package.feedType] }}
                            </a>
                        }
                        @if (package.feedType === checkFeed) {
                            <div style="display: flex; gap: 5px">
                                <a
                                    style="cursor: pointer"
                                    [class.disabled]="isDownloadDisabled(package)"
                                    (click)="download(package)"
                                >
                                    {{ feedTextMap[package.feedType] }}
                                </a>
                                <ws-ace-loader
                                    [class.invisible]="!package.isDownloading"
                                    [marginTop]="0"
                                    [inline]="true"
                                    [size]="1"
                                    [hasOverlay]="false"
                                ></ws-ace-loader>
                            </div>
                        }
                    </td>
                    <td>{{ package.paymentCount }}</td>
                    <td>{{ package.feedType === checkFeed ? package.dataHubStatus : 'N/A' }}</td>
                    <td>{{ isTransmittal ? package.specialInstructions : 'N/A' }}</td>
                    <td>
                        @if (package.feedType !== checkFeed) {
                            <button
                                style="margin: 0"
                                class="ace-btn has-icon btn-primary"
                                (click)="launchReviewModal(package)"
                            >
                                <i class="fa fa-file-export"></i>
                            </button>
                        }
                    </td>
                </tr>
            }
        </tbody>
    </table>
}

<ng-template #recipientAddress>
    @if (hoveredRecipient) {
        <address style="text-align: left; margin: 0">
            {{ hoveredRecipient.companyName }}
            <br />
            {{ hoveredRecipient.fullName }} <br />
            {{ hoveredRecipient.title }}
            @if (hoveredRecipient.address) {
                <div>
                    {{ hoveredRecipient.address.address1 }}
                    <br />
                    {{ hoveredRecipient.address.address2 }}
                    @if (hoveredRecipient.address.address2) {
                        <br />
                    }
                    {{ hoveredRecipient.address.city }}
                    @if (hoveredRecipient.address.city) {
                        <span>,</span>
                    }
                    {{ hoveredRecipient.address.abbr }} {{ hoveredRecipient.address.zip }}
                </div>
            }
        </address>
    }
</ng-template>
